import DefaultBlock from "/scripts/default/block";

export default class SVGMorph extends DefaultBlock {
	init() {}
}
